<template>
  <ModalContainer :show="show" @close="$emit('close')" :contentStyle="'border-radius: 20px;'">
    <template #header>
      <h5 class="font-weight-bold mb-0">{{ $t('resolution_note') }}</h5>
    </template>

    <template #body>
      <div class="form-group mb-3 d-flex align-items-center" style="gap: .6rem">
        <input id="confirm_seen" type="checkbox" v-model="form.confirm" :disabled="readOnly" />
        <label for="confirm_seen" class="mb-0 text-muted">{{ $t('confirm_seen_copy') }}</label>
      </div>

      <div class="form-group">
        <label class="text-muted mb-2">{{ $t('add_note') }}</label>
        <textarea
          class="form-control resolution-textarea"
          rows="6"
          v-model="form.note"
          :placeholder="$t('add_note_placeholder')"
          :readonly="readOnly"
        ></textarea>
      </div>
    </template>

    <template #footer>
      <button v-if="!readOnly" class="btn btn-primary" :disabled="!form.confirm" @click="submit" style="border-radius: 16px; padding: .6rem 1.6rem;">
        {{ $t('add') }}
      </button>
    </template>
  </ModalContainer>
</template>

<script>
import ModalContainer from '@/components/ModalContainer.vue';

export default {
  name: 'TriggeredAlarmResolution',
  components: { ModalContainer },
  props: {
    show: Boolean,
    alarm: {
      type: Object,
      default: () => ({}),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    initialNote: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        confirm: false,
        note: this.initialNote || '',
      },
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.form.note = this.initialNote || '';
        this.form.confirm = this.readOnly ? true : false;
      }
    },
    initialNote(newVal) {
      this.form.note = newVal || '';
    },
  },
  methods: {
    submit() {
      // Emit payload upward (store integration can be added later)
      this.$emit('submit', { ...this.form, alarm: this.alarm });
      this.form = { confirm: false, note: '' };
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.resolution-textarea {
  background: #f6f9ff;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}
</style>

<i18n>
{
  "en": {
    "resolution_note": "Resolution Note",
    "confirm_seen_copy": "Kindly click on the checkbox to confirm  you have seen the alarm",
    "add_note": "Add Note",
    "add_note_placeholder": "Type your resolution note here...",
    "add": "Add"
  },
  "fr": {
    "resolution_note": "Note de résolution",
    "confirm_seen_copy": "Veuillez cocher la case pour confirmer que vous avez vu l'alarme",
    "add_note": "Ajouter une note",
    "add_note_placeholder": "Saisissez votre note de résolution ici...",
    "add": "Ajouter"
  }
}
</i18n>
